import React from 'react';
import { useTranslation } from 'react-i18next';
import { GetClientsTask } from '~admin/interactor/client/perform-get-clients';
import { ClientProfileData } from '~admin/model/client-profile-data';
import { SelectFieldTask } from '~admin/view/components/ui/form/fields/field-select-task.component';
import { SelectFieldOption } from '~common/components/select.component';

export interface ClientDetailsFormData {
  clientId: number;
}

interface Props {
  task: GetClientsTask;
  disabled?: boolean;
}

export const ClientNameDropdown: React.FunctionComponent<Props> = ({ task, disabled }) => {
  const { t } = useTranslation();

  return (
    <SelectFieldTask
      name={'clientId'}
      label={t('createEvent.clientDetails.dropdown.clientNameLabel')}
      task={task}
      disabled={disabled}
      mapper={(result: ClientProfileData[]): SelectFieldOption[] =>
        result.map(({ name, id }) => ({
          name,
          value: id,
        }))
      }
    />
  );
};



// WEBPACK FOOTER //
// ./view/components/details/client-details/client-dropdowns/client-name-dropdown.component.tsx